import React from 'react';
import {observer} from 'mobx-react';
import {Route, Switch} from 'react-router-dom';
import DetailView from './DetailView';
import {historyMediaStore, playListMediaStore} from "../../store/MediaStore";
import HistoryView from "./HistoryView";
import PlayListView from "./PlayListView";
import axios from "axios";
import playListStore from "../../store/PlayListStore";
import CommonHelper from "../../helper/CommonHelper";
import qs from "qs";



@observer
class PlayListViewFrame extends React.Component {

    componentWillUnmount() {
        playListMediaStore.clear()
    }

    componentDidMount() {
        let {match:{params:{id}}} = this.props;
        let store = playListMediaStore;
        this.load(id)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        let {match:{params:{id}}} = this.props;
        let store = playListMediaStore;
        if(id !== prevProps.match.params.id){
            this.load(id)
        }
    }

    load(id){
        let store = playListMediaStore;
        axios.post(`/play/list/${id}`,{})
            .then(({data})=>{
                store.target = data;
                store.searchCondition.replace(CommonHelper.objectToMap({...qs.parse(this.props.location.search, { ignoreQueryPrefix: true }), playListId: data.id}));
                store.debounceFetch(true);
                playListStore.load()
            })

    }

    render() {
        return (
            <Switch>
                <Route path="/main/play/list/:id/:folderId/:fileId" component={DetailView}/>
                <Route path="/main/play/list/:id" component={PlayListView}/>
            </Switch>
        );

    }
}

export default PlayListViewFrame;
